import { useChartStore } from '../chart'
const chartStore = useChartStore()

import { GROUP_FILTER as gf } from '../../helpers/constants'

let development = false
try {
  development = import.meta.env.STORYBOOK === 'true'
} catch (_) {
  development = false
}

//eslint-disable-next-line
export const corporateStore = (axiosInstance, mocks, mockdb, apiUrl, addNotification) => {
  return {
    getters: {
      getActiveCustomer(state) {
        if (state.activeCustomerId) {
          return state.customers.find((customer) => customer.customerNumber === state.activeCustomerId)
        }
        return state.customers[0]
      }
    },
    actions: {
      async setGroupsOrder(context, payload) {
        let extraHeaders = null

        if (development) {
          extraHeaders = {
            headers: {
              currentGroupObject: JSON.stringify(context.state?.groups ?? []),
              payload: JSON.stringify(payload)
            }
          }
        }
        const response = await axiosInstance.post(apiUrl.setGroupsOrder.replace('{id}', context.state.activeCustomerId), payload, extraHeaders)

        if (response.status === 200) {
          context.commit('updateGroupsData', response.data.data)
        }
        return response
      },
      async fetchCustomers(context) {
        if (context.state.customers.length > 0) return { status: 200 }

        mocks.mockData(apiUrl.getCustomers, 1000, 'getCustomers')
        const response = await axiosInstance.get(apiUrl.getCustomers)

        if (response.status !== 200) {
          context.commit('updateGlobalServerError', response.status)
        } else {
          context.commit('updateCustomers', response.data.data)
          context.commit('updateActiveCustomerId', response.data.data[0].customerNumber)
        }

        return response
      },
      async fetchDeliverySitesData(context, payload) {
        let extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        extraParams += (payload.type === 'deliverysitegroup' || payload.type === 'deliverysitessearch') && payload.groupId ? `&groupId=${payload.groupId}` : ''
        extraParams += payload.type === 'deliverysitessearch' ? `&includeSelectOption=true` : ''

        const requestUrl = `${apiUrl.getDeliverySitesData}${payload.params}${extraParams}`

        let extraHeaders = null

        if (development && payload.type === 'deliverysitegroup' && payload.groupId) {
          const currentGroupDeliverySites = (context.state?.groups ?? []).find((item) => item.groupId == payload.groupId)
          extraHeaders = {
            headers: {
              currentGroupDeliverySites: JSON.stringify(currentGroupDeliverySites.deliverySiteIds)
            }
          }
        }

        const response = await axiosInstance.get(requestUrl, extraHeaders)

        if (response.status === 200 && !payload.groupsActive && !payload.groupId) context.commit('updateDeliverySitesData', { response: response.data, type: payload, reset: payload.reset })

        if (response.status === 200 && payload.type === 'deliverysiteslist') context.commit('updateDeliverySiteGroupData', { response: response.data, type: payload, reset: payload.reset })
        if (response.status === 200 && payload.type === 'deliverysitegroup') context.commit('updateGroupData', { response: response.data, type: payload, reset: payload.reset, groupId: payload.groupId })
        if (response.status === 200 && payload.type === 'deliverysitessearch') context.commit('updateDeliverySitesSearchData', { response: response.data, type: payload, reset: payload.reset })

        return response
      },
      async fetchGroupsData(context) {
        if (!context.state.activeCustomerId) return {}
        const requestUrl = `${apiUrl.getGroupsData.replace('{id}', `?customerId=${context.state.activeCustomerId}` ?? '')}`

        const response = await axiosInstance.get(requestUrl)

        if (response.status === 200) context.commit('updateGroupsData', response.data.data)
        else context.commit('updateGroupsData', [])

        return response
      },
      async fetchPowerOutageNotificationTableData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.getPowerOutageNotificationTableData}${payload.params}${extraParams}`

        mocks.mockPowerOutageNotificationTableData(requestUrl, 2000, payload)
        const response = await axiosInstance.get(requestUrl)

        if (response.status === 200) context.commit('updatePowerOutageNotificationTableData', { response: response.data, type: payload, reset: payload.reset })
        return response
      },
      async fetchActiveSubscriptions(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.getPowerOutageNotificationsData}${payload.params}${extraParams}`

        mocks.mockData(requestUrl, 2000, 'getActiveSubscriptions')
        const response = await axiosInstance.get(requestUrl)

        if (response.status === 200) context.commit('updateActiveSubscriptions', response.data)
        return response
      },
      async postAppInsightsData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.appInsight}?tabName=${payload}${extraParams}`

        mocks.mockPost(requestUrl, {}, mockdb.randomNumber(1000, 3000), 'postAppInsightsData')
        await axiosInstance.post(requestUrl, {})
      },
      async postPowerOutageNotificationsBatch(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.postPowerOutageNotificationsBatch}${payload.params}${extraParams}`

        mocks.mockPost(requestUrl, payload.body, mockdb.randomNumber(1000, 3000), 'postPowerOutageNotificationsBatch')

        const response = await axiosInstance.post(requestUrl, payload.body)
        if (response.status === 200) context.commit('updatePowerOutageNotificationTableData', { response: response.data, reset: true })

        addNotification(context, response)
        return response
      },
      async postHandleGroups(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.postGroupsData.replace('{id}', payload.groupId ?? '')}${extraParams}`

        payload.currentGroupId = payload.groupId

        delete payload.groupId
        delete payload.dispatch

        let extraHeaders = null

        if (development) {
          extraHeaders = {
            headers: {
              currentGroupObject: JSON.stringify(context.state?.groups ?? [])
            }
          }
        }

        const response = await axiosInstance.post(requestUrl, payload, extraHeaders)
        if (response.status === 200) context.commit('updateGroupsData', response.data.data)

        addNotification(context, response)
        return response
      },
      async postDeliverySiteCustomName(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.postDeliverySiteCustomName.replace('{id}', payload.id ?? '')}${extraParams}`
        const response = await axiosInstance.post(requestUrl, payload)

        addNotification(context, response)
        if (response.status === 200) {
          const newDeliverySitesGroupsData = context.state.deliverySitesGroupsData?.items
          if (newDeliverySitesGroupsData && newDeliverySitesGroupsData.length > 0) {
            const updatedDeliverySitesGroupsData = newDeliverySitesGroupsData?.map((site) => {
              if (site[0] && site[0].value === payload.id && site.length > 2) {
                let updatedSite = [...site]
                updatedSite[2] = { ...updatedSite[2], text: payload.name }
                return updatedSite
              }
              return site
            })

            context.commit('replaceDeliverySitesGroupsDataItems', updatedDeliverySitesGroupsData)
          }

          const newDeliverySitesData = context.state.deliverySitesData?.items
          if (newDeliverySitesData && newDeliverySitesData.length > 0) {
            const updatedDeliverySitesData = newDeliverySitesData?.map((site) => {
              if (site[0] && site[0].value === payload.id && site.length > 2) {
                let updatedSite = [...site]
                updatedSite[2] = { ...updatedSite[2], text: payload.name }
                return updatedSite
              }
              return site
            })

            context.commit('replaceDeliverySitesDataItems', updatedDeliverySitesData)
          }

          return response
        }
      },
      async deleteDeliverySiteCustomName(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.deleteDeliverySiteCustomName.replace('{id}', payload ?? '')}${extraParams}`

        const response = await axiosInstance.delete(requestUrl, payload)
        addNotification(context, response)

        if (response.status === 200) {
          const newDeliverySitesGroupsData = context.state.deliverySitesGroupsData?.items
          if (newDeliverySitesGroupsData && newDeliverySitesGroupsData.length > 0) {
            const updatedDeliverySitesGroupsData = newDeliverySitesGroupsData?.map((site) => {
              if (site[0] && site[0].value === payload && site.length > 2) {
                let updatedSite = [...site]
                updatedSite[2] = { ...updatedSite[2], text: null }
                return updatedSite
              }
              return site
            })

            context.commit('replaceDeliverySitesGroupsDataItems', updatedDeliverySitesGroupsData)
          }

          const newDeliverySitesData = context.state.deliverySitesData.items
          if (newDeliverySitesData && newDeliverySitesData.length > 0) {
            const updatedDeliverySitesData = newDeliverySitesData.map((site) => {
              if (site[0] && site[0].value === payload && site.length > 2) {
                let updatedSite = [...site]
                updatedSite[2] = { ...updatedSite[2], text: null }
                return updatedSite
              }
              return site
            })

            context.commit('replaceDeliverySitesDataItems', updatedDeliverySitesData)
          }
        }

        return response
      },
      async removeGroup(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.deleteRemoveGroup.replace('{id}', payload.groupId ?? '')}${extraParams}`

        mocks.mockDelete(requestUrl, payload, mockdb.randomNumber(500, 1000), payload.dispatch)

        delete payload.groupId
        delete payload.dispatch

        const response = await axiosInstance.delete(requestUrl, payload)
        if (response.status === 200) {
          context.commit('updateGroupsData', response.data.data)
          context.commit('updateDeliverySiteGroupFilter', gf.GROUPS)
        }

        addNotification(context, response)
        return response
      },
      async fetchConsumptionDataCombined(context, payload) {
        if (!context.state.myPagesCorporate) return

        const extraParams = `?customerId=${context.state.activeCustomerId}`
        const requestUrl = `${apiUrl.getConsumptionDataCombined}${payload}${extraParams}`

        mocks.mockData(requestUrl, 1000, 'getConsumptionDataCombined')

        axiosInstance.get(requestUrl).then((response) => {
          if (response.status === 200) {
            let data = response.data.data
            let ConsumptionEstimatedYearlyReactive = data.consumptionSummary.estimatedYearlyReactive?.value ?? '0'
            let ProductionEstimatedYearlyReactive = data.productionSummary.estimatedYearlyReactive?.value ?? '0'
            let TotalEstimatedYearlyReactive = parseInt(ConsumptionEstimatedYearlyReactive.replaceAll(' ', '')) + parseInt(ProductionEstimatedYearlyReactive.replaceAll(' ', ''))

            let ConsumptionCurrentYearReactive = data.consumptionSummary.currentYearReactive?.value ?? '0'
            let ProductionCurrentYearReactive = data.productionSummary.currentYearReactive?.value ?? '0'
            let TotalCurrentYearReactive = parseInt(ConsumptionCurrentYearReactive.replaceAll(' ', '')) + parseInt(ProductionCurrentYearReactive.replaceAll(' ', ''))

            data['reactiveSummary'] = {
              estimatedYearlyReactive: {
                unit: data.consumptionSummary.estimatedYearlyReactive?.unit ?? 'kVA',
                value: TotalEstimatedYearlyReactive.addThousandSeperator(),
                periodDescription: data.consumptionSummary.estimatedYearlyReactive?.periodDescription ?? ''
              },
              currentYearReactive: {
                unit: data.consumptionSummary.currentYearReactive?.unit ?? 'kVA',
                value: TotalCurrentYearReactive.addThousandSeperator(),
                periodDescription: data.consumptionSummary.currentYearReactive?.periodDescription ?? ''
              }
            }

            context.commit('updateConsumptionData', { response: data, id: payload, setActiveDeliverySite: true })
          }
        })
      },
      CLEAR_groups(context) {
        context.commit('updateGroupsData', [])
      },
      SET_deliverySiteGroupFilter(context, payload) {
        context.commit('updateDeliverySiteGroupFilter', payload)
      },
      TOGGLE_deliverySiteEditModeActive(context, active) {
        context.commit('updateDeliverySiteEditModeActive', active === undefined ? !context.state.deliverySite_EditModeActive : active)
      },
      SET_activeCustomerId(context, id) {
        context.commit('updateActiveCustomerId', id)
      },
      SET_initiallyChosenDeliverySiteId(context, id) {
        context.commit('updateInitiallyChosenDeliverySiteId', id)
      },
      SET_deliverySiteSelectorOnPage(context, payload) {
        context.commit('updateDeliverySiteSelectorOnPage', payload)
      },
      SET_tabValue(context, tabValue) {
        context.commit('setTabValue', tabValue)
      }
    },
    mutations: {
      updateCustomers(state, payload) {
        state.customers = payload
      },
      updateGlobalServerError(state, payload) {
        state.globalServerError = payload
      },
      updateActiveCustomerId(state, id) {
        const customerObject = state.customers.find((customer) => customer.customerNumber === id)

        state.activeCustomerId = id
        state.activeCustomer = customerObject

        chartStore.$reset({
          currentCustomer: JSON.parse(JSON.stringify(customerObject)),
          pending: true
        })
      },
      updateInitiallyChosenDeliverySiteId(state, id) {
        state.initiallyChosenDeliverySiteId = id
      },
      setTabValue(state, tabValue) {
        state.tabValue = tabValue

        //TODO: Should tabValue be saved in store?
        chartStore.tabValue = tabValue
      },
      updateDeliverySitesData(state, payload) {
        state.deliverySitesData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.deliverySitesData.items, ...(payload.response.data?.items ?? [])],
          reset: payload.reset
        }
      },
      replaceDeliverySitesDataItems(state, payload) {
        state.deliverySitesData = {
          ...state.deliverySitesData,
          items: payload
        }
      },
      replaceDeliverySitesGroupsDataItems(state, payload) {
        state.deliverySitesGroupsData = {
          ...state.deliverySitesGroupsData,
          items: payload
        }
      },
      updateGroupsData(state, payload) {
        const groupsObject = payload.map((group) => ({ ...group, id: `group/${group.id}`, groupId: group.id, listId: `deliverysitegroup-${group.id}-${group.deliverySiteIds.length}`, isConsumptionSite: true }))
        state.groups = groupsObject
      },
      updateSingleGroupId(state, groups) {
        state.groups = groups
      },
      updateDeliverySiteGroupFilter(state, payload) {
        state.deliverySite_GroupFilter = payload
      },
      updateDeliverySiteEditModeActive(state, payload) {
        state.deliverySite_EditModeActive = payload
      },
      updateGroupData(state, payload) {
        state.groupData[payload.groupId] = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.groupData[payload.groupId].items, ...(payload.response.data?.items ?? [])],
          reset: payload.reset
        }
      },
      updateDeliverySiteGroupData(state, payload) {
        state.deliverySitesGroupsData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.deliverySitesGroupsData.items, ...(payload.response.data?.items ?? [])],
          reset: payload.reset
        }
      },
      updateDeliverySitesSearchData(state, payload) {
        state.deliverySitesSearchData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.deliverySitesSearchData.items, ...(payload.response.data?.items ?? [])],
          reset: payload.reset
        }
      },
      updatePowerOutageNotificationTableData(state, payload) {
        state.powerOutageNotificationTableData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.powerOutageNotificationTableData.items, ...(payload.response.data?.items ?? [])],
          reset: payload.reset
        }
      },
      updateConsumptionDataCombined(state, payload) {
        state.consumptionDataCombined = payload
        state.consumptionDataReady = true
      },
      updateDeliverySiteSelectorOnPage(state, payload) {
        state.deliverySiteSelectorOnPage = payload
      },
      updateActiveSubscriptions(state, payload) {
        state.activeSubscriptions = payload
      }
    }
  }
}
